import React from "react";
import Popup from 'reactjs-popup';
import './AddProject.css';
import 'reactjs-popup/dist/index.css';
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Row,
    Col,
    Button,
  } from "reactstrap";
import {Diff2HtmlUI} from "diff2html/lib/ui/js/diff2html-ui-slim.js";
import BeatLoader from "react-spinners/BeatLoader";


function CommitDiff(props) {
    const [loading, setLoading] = React.useState("false");

    async function loadDiff(){
        console.log("Get Diff...");
        var diffString ="";
        var text="";
        if(props.file!=""){
            setLoading("true");
            try {
                const response = await fetch(process.env.REACT_APP_API_URL + '/urgent/file/neighborhood/commitdiff?owner='+process.env.REACT_APP_ORG+'&name=' + props.projectName +'&file='+props.file,//+props.filepath,
                    {
                        method: "GET",
                        redirect: "follow",
                        headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
                    }
                );
                if(response.status === 200) {
                    text = await response.text();
                    diffString= text;
                }
                else {
                    console.log("API error");
                }
            } catch (error) {
                console.error("Error:", error);
            }

            setLoading("false");
            const targetElement = document.getElementById('content-diff-id');
            const configuration = { drawFileList: true, matching: 'lines' };
            const diff2htmlUi = new Diff2HtmlUI(targetElement, diffString, configuration);
            diff2htmlUi.draw();
        }
    }

    function closeModal(close){
        close();
    }

    return (
        <div style={{textAlign:"center", display:"flex", justifyContent:"space-evenly"}}>

                <Popup contentStyle={{width:"1000px"}} trigger={
                    <button style={{borderRadius:"5px"}}> diff </button>} 
                    modal nested>

                {close => (
                    <div className="modal">
                        <button className="close" onClick={close}>
                            &times;
                        </button>
                        <div className="header"> Diff </div>
                        <div style={{maxHeight:"80vh", overflowX:"auto"}}>
                            <Button onClick={loadDiff}>Load Diff</Button>
                            {loading=="true" && 
                                <BeatLoader color={"#119f50"} />}
                            <div id="content-diff-id" className="content"/>
                        </div>
                    </div>
                )}
                </Popup>

        </div>
    );
}

export default CommitDiff;